import {GetIHeliNetwork} from '../singleton_registry';

import {callbackHsOnCatchError} from './callbackHsOnCatchError ';
import {
  ETextParamType_PlayVideo,
  ETextParamType_StopVideo,
  ETextParamType_SetGenericWindowState,
  ETextParamType_OnPlayScreenShare,
  ETextParamType_VideoEnded,
  __MEDIASTREAM__
} from './const';
import {
  getPendingAutoPlayRequest,
  setPendingAutoPlayRequest,
  setVideoInitialized,
  setVideoMediastreamSrc,
  setVideoEndedToggle,
  setVideoCanPlayToggle
} from './dataOps';
import {getVideo, setVideo} from './domOps';
import {hel_setText} from './moduleCaller';
/** 画面共有 */
let g_useVideoStreamFlag = true;

/** ビデオストリーム保持用Map */
export const videoStreams = new Map();

/** MediaStream再生用 */
const g_VideoMediaStreamSrcObject: MediaStream | null = null;

// 動画時間同期再生用基準日時 unixtimestamp(ミリ秒) 2024/4/10 20:24:53 -> 1712748293437
let videoSyncPlayBaseTime: number | null = null;
let videoSyncPlayIntervalIdx: number | null = null;

export const hel_set_video_stream_use = (flag: boolean) => {
  g_useVideoStreamFlag = flag;
  return g_useVideoStreamFlag;
};

export const hel_get_video_stream_use = () => {
  return g_useVideoStreamFlag;
};

export const helcore_video_play = (
  itemName: string,
  materialName: string,
  fileName: string,
  loop: boolean,
  streaming: boolean,
  seekbar: boolean,
  playSyncBaseTime: number | null
) => {
  setCurrentVideoPlayTarget({itemName, materialName});
  hel_setText(
    ETextParamType_PlayVideo,
    itemName +
      ',' +
      materialName +
      ',' +
      fileName +
      ',' +
      (loop ? 'true' : 'false') +
      ',' +
      (streaming ? 'true' : 'false') +
      ',' +
      (seekbar ? 'true' : 'false') +
      ',' +
      (playSyncBaseTime ?? '')
  );
};

export const helcore_video_play_mediastream = (
  itemName: string,
  materialName: string,
  mediaStream: MediaStream,
  loop: boolean,
  streaming: boolean,
  seekbar: boolean,
  playSyncBaseTime: number | null
) => {
  setVideoMediastreamSrc(mediaStream);
  setCurrentVideoPlayTarget({itemName, materialName});

  hel_setText(
    ETextParamType_PlayVideo,
    itemName +
      ',' +
      materialName +
      ',' +
      __MEDIASTREAM__ +
      ',' +
      (loop ? 'true' : 'false') +
      ',' +
      (streaming ? 'true' : 'false') +
      ',' +
      (seekbar ? 'true' : 'false') +
      ',' +
      (playSyncBaseTime ?? '')
  );
};

export const hel_video_stop = () => {
  hel_setText(ETextParamType_StopVideo, '');
  globalThis.g_VideoPlayerType = null;
};

export const hel_video_is_paused = (): boolean => {
  const video = getVideo();
  if (video === undefined) {
    return true;
  }
  return video.paused;
};

export const hel_video_open_genericwindow = () => {
  hel_setText(ETextParamType_SetGenericWindowState, 'movieviewer' + ',' + 'open' + ',' + '');
};

export const hel_video_close_genericwindow = () => {
  hel_setText(ETextParamType_SetGenericWindowState, 'movieviewer' + ',' + 'close' + ',' + '');
};

export const hel_skyway_stop_screen_sharing_via_room = async () => {
  GetIHeliNetwork()?.stopScreenShare();
};

/** 画面共有の再生開始 */
export const hel_skyway_play_remote_video_stream = (
  remoteVideoStream: MediaStream,
  videoItemName: string,
  videoMaterialName: string
) => {
  // 動画の開始 ※本来ならMediaStreamを直接再生したい
  hel_video_stop();
  helcore_video_play_mediastream(
    videoItemName,
    videoMaterialName,
    remoteVideoStream,
    true,
    false,
    false,
    null
  );

  // HeliScriptのコールバックを呼び出す
  hel_setText(ETextParamType_OnPlayScreenShare, '');
};

export const hel_video_is_playing_same_stream = (stream: MediaStream) => {
  const video = getVideo();
  const videoId = video?.paused === false && video.srcObject && (video.srcObject as MediaStream).id;
  return videoId === stream.id;
};

/**
 * @remarks
 * C++から呼出し
 * @param loop
 */
export const helcpp_video_Prepare = (loop: boolean) => {
  const video = getVideo();
  if (video !== undefined) {
    video.loop = loop;
    return;
  }

  // 動画の
  helcore_video_syncplay_init_adjuster_interval();
  // document.pictureInPictureEnabled = false;

  // globalThis.g_Video = document.createElement('video');
  const updatedVideo = document.getElementById('video0') as HTMLVideoElement;
  setVideo(updatedVideo);

  // globalThis.g_Video.autoplay = false;
  updatedVideo.loop = loop;
  // globalThis.g_Video.type = 'video/mp4';
  // globalThis.g_Video.autoPictureInPicture = false;
  // globalThis.g_Video.disablePictureInPicture = true;
  // globalThis.g_Video.controlslist = "nodownload";
  // globalThis.g_Video.playsinline = true;

  setVideoEndedToggle(false);

  updatedVideo.onseeking = () => setVideoCanPlayToggle(false);

  updatedVideo.onseeked = () => setVideoCanPlayToggle(true);

  updatedVideo.oncanplay = () => setVideoCanPlayToggle(false);

  updatedVideo.oncanplaythrough = () => {
    setVideoCanPlayToggle(true);
  };

  updatedVideo.onerror = function () {
    this.onerror = null;
  };

  updatedVideo.addEventListener('error', (e) => {
    const reason = getReasonFromMediaErrorEvent(e);
    callbackVideoErrorToCpp(reason);
  });

  updatedVideo.onended = (event: Event) => {
    // console.debug(`g_Video onEnded ${JSON.stringify(event)}`);
    setVideoEndedToggle(true);
    hel_setText(ETextParamType_VideoEnded, '');
  };

  updatedVideo.addEventListener('loadedmetadata', () => {
    if (typeof globalThis.hel_video_on_loadedmetadata === 'function') {
      globalThis.hel_video_on_loadedmetadata();
    }
  });
};
const getReasonFromMediaErrorEvent = (event: Event): string => {
  const target = event.currentTarget as HTMLMediaElement | null;
  const mediaError = target?.error;
  if (!mediaError) return 'UnknownError';

  switch (mediaError.code) {
    case MediaError.MEDIA_ERR_ABORTED:
      return 'LoadAborted';
    case MediaError.MEDIA_ERR_NETWORK:
      return 'NetworkError';
    case MediaError.MEDIA_ERR_DECODE:
      return 'DecodeError';
    case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
      return 'SrcNotSupported';
    default:
      return 'UnknownError';
  }
};
export const helcore_video_syncplay_set_basetime = (baseUnixTime: number): void => {
  videoSyncPlayBaseTime = baseUnixTime;
};
export const helcore_video_syncplay_clear_basetime = (): void => {
  videoSyncPlayBaseTime = null;
};
export const helcore_video_syncplay_get_basetime = (): number | null => {
  return videoSyncPlayBaseTime;
};
export const helcore_video_syncplay_adjust_currenttime = (
  video: HTMLVideoElement,
  baseUnixTime: number,
  allowSmallDiff = false
) => {
  // 動画の全体尺
  const duration = Math.floor(video.duration * 1000) / 1000;
  // 現在時刻
  const currentTime = new Date();
  // 同期基準時刻
  const baseTime = new Date(baseUnixTime);
  // 基準時刻との差分
  const diffTime = (currentTime.getTime() - baseTime.getTime()) / 1000;

  // 動画が非ループ時の制御
  if (video.loop === false) {
    // 基準時間から再生時間を足して超過していたら動画の最期へシーク
    if (diffTime > video.duration) {
      video.currentTime = video.duration;
      return;
    }
    // TODO
    // 基準時間より前の場合の処理は別途検討が必要 一旦最後へシーク
    if (diffTime < 0) {
      video.currentTime = video.duration;
      return;
    }
  }
  // 差分を動画の全体尺で割った余りが現在の再生位置
  const syncDiff = diffTime % duration;
  const syncDuration = syncDiff >= 0 ? syncDiff : duration + syncDiff;
  const diffCurrentTime = Math.abs(video.currentTime - syncDuration);
  // 差分が小さい分には無視する判定
  if (allowSmallDiff && diffCurrentTime < 0.6) {
    return;
  }
  video.currentTime = syncDuration;
};

const helcore_video_syncplay_init_adjuster_interval = (): void => {
  if (videoSyncPlayIntervalIdx) {
    console.error('video syncplay adjuster interval existed');
    return;
  }
  videoSyncPlayIntervalIdx = window.setInterval(() => {
    const video = getVideo();
    const baseUnixTime = helcore_video_syncplay_get_basetime();
    if (
      video === undefined ||
      video.readyState === 0 ||
      video.paused === true ||
      baseUnixTime === null
    ) {
      return;
    }
    helcore_video_syncplay_adjust_currenttime(video, baseUnixTime, true);
  }, 500);
};

const helcore_video_syncplay_clear_adjuster_interval = (): void => {
  if (videoSyncPlayIntervalIdx) {
    window.clearInterval(videoSyncPlayIntervalIdx);
    videoSyncPlayIntervalIdx = null;
  }
};

type DummyMediaResult = {
  stream: MediaStream;
  cleanup: () => void;
};

export const createDummyMediaStream = (): DummyMediaResult => {
  const canvas: HTMLCanvasElement = document.createElement('canvas');
  canvas.width = 640;
  canvas.height = 360;

  const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
  if (ctx) {
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }
  let animationFrameId: number;
  // iPhoneでplay()が正常に進むようにアニメーションループさせる
  const drawLoop = () => {
    ctx?.fillRect(0, 0, canvas.width, canvas.height);
    animationFrameId = requestAnimationFrame(drawLoop);
  };
  drawLoop();
  const fps = 30;
  const videoStream = canvas.captureStream(fps);
  const videoTrack = videoStream.getVideoTracks()[0];
  if (!videoTrack) throw new Error();

  const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  const oscillator = audioCtx.createOscillator();
  const dst = audioCtx.createMediaStreamDestination();

  // NOTE: connect しても、自動的に oscillator.start() されることはない
  // 必要なら createDummyMediaStream 側で start() を外に出して実行し、cleanup で oscillator.stop() も実行する
  // ※必ず start() が実行されるのでなければ、ラッパーでフラグ管理し、実行された場合のみ stop() を実行する
  oscillator.connect(dst);
  oscillator.frequency.value = 0;

  const audioTrack = dst.stream.getAudioTracks()[0];
  if (!audioTrack) throw new Error();
  const combinedStream = new MediaStream([videoTrack, audioTrack]);

  const cleanup = () => {
    cancelAnimationFrame(animationFrameId);
    // TODO: 動画再生周りの挙動はアプデで変わる可能性が高いため、コメントアウトでコードを残す
    // oscillator.start() を行う場合、コメントアウトを外す
    // https://github.com/VRHIKKY/WorldViewer/pull/15651#discussion_r2242347375
    // ※oscillator.start() せずに oscillator.stop() すると例外が発生する
    // https://developer.mozilla.org/ja/docs/Web/API/AudioScheduledSourceNode/stop#%E4%BE%8B%E5%A4%96
    // try {
    //   oscillator.stop();
    // } catch (e) {
    //   console.error(e);
    // }
    try {
      audioCtx.close();
    } catch (e) {
      console.error(e);
    }
    try {
      videoTrack.stop();
    } catch (e) {
      console.error(e);
    }
    try {
      audioTrack.stop?.();
    } catch (e) {
      console.error(e);
    }
    try {
      canvas.remove();
    } catch (e) {
      console.error(e);
    }
    // null代入はGCに任せるのでこの関数内では不要
  };

  return {
    stream: combinedStream,
    cleanup
  };
};

export const setupVideoInitEvents = () => {
  let videoInitFlg = false;
  helcpp_video_Prepare(false);
  const video = getVideo();
  if (!video) {
    console.error('Video Initialize Error. can not get video');
    return;
  }

  const {stream: dummyStream, cleanup} = createDummyMediaStream();

  const initVideo = () => {
    if (videoInitFlg) return;
    videoInitFlg = true;
    setVideoInitialized(true);

    document.removeEventListener('mousedown', initVideo, options);
    document.removeEventListener('keydown', initVideo, options);
    document.removeEventListener('touchstart', initVideo, options);

    video.srcObject = dummyStream;

    video.play().then(() => {
      video.addEventListener(
        'pause',
        () => {
          cleanup(); // リソース解放
          const pendingRequest = getPendingAutoPlayRequest();
          if (pendingRequest) {
            helcore_video_play(
              pendingRequest.itemName,
              pendingRequest.materialName,
              pendingRequest.src,
              pendingRequest.loop,
              pendingRequest.streaming,
              true,
              pendingRequest.playSyncBaseTime
            );
            setPendingAutoPlayRequest(null);
          }
        },
        {once: true}
      );

      video.pause();
    });
  };

  const options = {capture: true};
  document.addEventListener('mousedown', initVideo, options);
  document.addEventListener('keydown', initVideo, options);
  document.addEventListener('touchstart', initVideo, options);
};
export const videoPlayErrorHandler = (error: DOMException) => {
  console.error(error);
  const reason = getReasonFromException(error);
  callbackVideoErrorToCpp(reason);
};

const getReasonFromException = (error: DOMException): string => {
  switch (error.name) {
    case 'NotAllowedError':
      return 'PlayNotAllowed';
    case 'NotSupportedError':
      return 'PlayNotSupported';
    case 'AbortError':
      return 'PlayAborted';
    case 'SecurityError':
      return 'SecurityViolation';
    case 'InvalidStateError':
      return 'InvalidState';
    default:
      return 'UnknownError';
  }
};

type CurrentVideoPlayTarget = {
  itemName: string;
  materialName: string;
};

let currentVideoPlayTarget: CurrentVideoPlayTarget | null = null;

export const getCurrentVideoPlayTarget = (): CurrentVideoPlayTarget | null => {
  return currentVideoPlayTarget;
};

export const setCurrentVideoPlayTarget = (target: CurrentVideoPlayTarget) => {
  currentVideoPlayTarget = target;
};
/**
 * 動画再生情報型
 *
 * `hel_video_play()` に渡す項目と同じ
 */
export type VideoPlayInfo = {
  itemName: string;
  materialName: string;
  src: string;
  loop: boolean;
  streaming: boolean;
  playSyncBaseTime: number | null;
};
let videoPlayInfo: VideoPlayInfo | null = null;
export const setVideoPlayInfo = (info: VideoPlayInfo) => {
  videoPlayInfo = info;
};
export const getVideoPlayInfo = (): VideoPlayInfo | null => {
  return videoPlayInfo;
};
export const callbackVideoErrorToCpp = (reason: string) => {
  const videoPlayInfo = getVideoPlayInfo();

  const errorObject: {reason: string; videoPlayInfo?: VideoPlayInfo} = {
    reason: reason
  };

  if (videoPlayInfo) {
    errorObject.videoPlayInfo = videoPlayInfo;
  }

  console.error('VIDEO ERROR:', errorObject);

  callbackHsOnCatchError(videoPlayInfo?.itemName ?? null, 'Video', errorObject);
};
